import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/group',
    name: 'group',
    component: () => import(/* webpackChunkName: "group" */ '../views/group')
  },
  {
    path: '/couponList',
    name: 'couponList',
    component: () => import(/* webpackChunkName: "couponList" */ '../views/couponList')
  },
  {
    path: '/errTip',
    name: 'errTip',
    component: () => import(/* webpackChunkName: "errTip" */ '../views/errTip')
  },
  {
    path: '/rule',
    name: 'rule',
    component: () => import(/* webpackChunkName: "rule" */ '../views/rule')
  }
]

const router = new Router({
  base: '/web-new-coupon',
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0, y: 0
    }
  }
})

export default router
